
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import EmployeeService from "../../services/resource/employeeService";
import LOGO from '../../assets/york.png'
import InputForm from "../../components/input/input";
import ButtonLoading from "../../components/buttonLoading/buttonLoading";
import './styles.css'

function Login() {
    const service = new EmployeeService();
    const auth = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const login = (event) => {
        event.preventDefault();
        setLoading(true);
        var emailConcat = ''
        if (!email.includes("@")) {
            emailConcat = email.trim() + '@distribuidorayork.com.br';
        } else {
            emailConcat = email;
        }
        service.authenticate({
            email: emailConcat,
            password: password
        }).then((response) => {
            auth.login(response.data, response.data.token);
            navigate('/');
            setLoading(false);
        }).catch((error) => {
            setError(error.response.data.message);
            setLoading(false);

        })
    };

    useEffect(() => {
        setError('')
    }, [email, password])

    return (
        <div style={{height:'100vh'}} className="flex heigth-full items-center justify-center px-4">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <div className="flex justify-center mb-6">
                    <img src={LOGO} alt="LOGO YORK" className="h-12 w-auto" />
                </div>

                <form onSubmit={login} className="space-y-6">
                    <div>
                        <InputForm
                            id="email"
                            type="text"
                            label="Nome de usuário ou e-mail"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div>
                        <InputForm
                            id="password"
                            type="password"
                            label="Senha"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    {error && <p className="text-sm text-red-600">{error}</p>}

                    <div className="text-left">
                        <button
                            type="button"
                            className="text-sm text-indigo-600 hover:underline"
                            onClick={() => navigate('/solicitar-nova-senha')}
                        >
                            Esqueceu ou não sabe a senha?
                        </button>
                    </div>
                    <div className="flex justify-center mt-4">
                        <ButtonLoading
                            label="Entrar"
                            color="indigo"
                            loading={loading}
                        />
                    </div>
                </form>
            </div>
        </div >
    );
}

export default Login;